import { render, staticRenderFns } from "./AdminPageServices.vue?vue&type=template&id=ae02e4c0"
import script from "./AdminPageServices.vue?vue&type=script&lang=js"
export * from "./AdminPageServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports